import request from 'superagent';
import { setFeedback, delayedClearFeedback, clearFeedback } from './feedback';
import { closeModal, openCartModal } from './active_modal';
import { openUpgradeFlowModal } from '../modules/active_modal';
import { clearLoginError } from './login_error';
import { setCustomer} from './customer';
import { setLoggedIn } from './is_logged_in';
import { createCookie } from '../shared/cookie';
import { setPath } from './path';
import { setActiveUpgradeStepTerms } from './active_upgrade_step';
import { setComputedCart } from './computed_cart';
import { fireUpgradeStatus, clearUpgradeStatus } from './upgrade_status';
import { getCustomerPaymentMethods } from './payment_methods';

export function upgradePositiveMemberSoft(){
  return (dispatch, getState) => {
    return dispatch([
      setPath('/catalog'),
      fireUpgradeStatus(),
      setComputedCart( getState().customer, getState().computedCart , [null, null] ),
      openUpgradeFlowModal()
    ]);
  }
}

export function unSoftUpgradePositiveMember(){
  return (dispatch, getState) => {
    return dispatch([
      setPath('/catalog'),
      clearUpgradeStatus(),
      setComputedCart( getState().customer, getState().computedCart , [] ),
      closeModal()
    ]);
  }
}


export function upgradeAccount(oUpdate) { //catalog upgrade
  return (dispatch, getState) => {
    request
      .put('/svc/customer/upgradeAccount?sap_account_number=' + oUpdate.account_number  + '&zip=' + oUpdate.zip )
      .send({
        'email': oUpdate.email,
        'password': oUpdate.password
      })
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200) {
          let errorMessage = "We couldn't find that catalog number in our database.";
          if (res && res.statusText && res.status !== 404 ) errorMessage = res.statusText;
          return dispatch([
            setFeedback(errorMessage),
            delayedClearFeedback()
          ]);
        } else {
          if( getState().store.type === "Neglite")
            return dispatch([
              getCustomerPaymentMethods(),
              fireUpgradeStatus(),
              openUpgradeFlowModal(),
              setActiveUpgradeStepTerms(),
              setFeedback("You have successfully upgraded with your catalog account."),
              delayedClearFeedback(),
              setCustomer(res.body),
              clearLoginError()
            ]);
          else
            return dispatch([
              getCustomerPaymentMethods(),
              setFeedback("You have successfully upgraded with your catalog account."),
              delayedClearFeedback(),
              setCustomer(res.body),
              clearLoginError(),
              closeModal()
            ]);
        }
      });
  }
}


export function closeAccount() { 
  return (dispatch, getState) => {
    request
      .post('/svc/customer/cancelAccount')
      .send()
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200) {
          let errorMessage = "Sorry, We couldn't automatically cancel your account, please call member services.";
          if (res && res.statusText) errorMessage = res.statusText;
          return dispatch([
            setFeedback(errorMessage),
            delayedClearFeedback()
          ]);
        } else {
          return dispatch([,
            setFeedback("You have successfully cancelled your account."),
            delayedClearFeedback(),
            setCustomer(),
            clearLoginError(),
            closeModal()
          ]);
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/modules/membership_actions.js